import { useAppSelector } from 'app';

/**
 * Returns true when the current session is an Infinity DMS user on a hosted dealer.
 * Used to gate features that should only apply to Infinity hosted dealers.
 */
export const useIsInfinityHostedDealer = (): boolean => {
  const isHostedDealer = useAppSelector((state) => state.user.isHosted);
  return isHostedDealer && localStorage.getItem('Login_Source')?.toString() === 'DMS_INFINITY';
};

export default useIsInfinityHostedDealer;
